// extracted by mini-css-extract-plugin
export default {"box":"Demo_box__HZOl8","title":"Demo_title__g3hbU","body":"Demo_body__2DDWx"};